import { NextRouter } from 'next/router'

import { CurriculumCountryCodes } from '~/curriculum/constants/curriculum.const'

export function extractCountryCodeAndGradeIdAndSubjectFromQueryParams(
  params:
    | {
        countryCode: string
        grade: string
        subject: string
      }
    | undefined,
): { countryCode: string; gradeId: string; subjectOrder: string } {
  const grade = params?.grade as string
  const countryCode = (params?.countryCode as string).split('-')[1]
  const gradeId = `${countryCode === 'default' || countryCode === 'ua' ? 'us' : countryCode}-grade-${grade}`
  const subjectOrder = (params?.subject as string) || ''

  return { countryCode, gradeId, subjectOrder }
}

export function extractCountryCodeAndGradeIdFromRouterPath(router: NextRouter): {
  countryCode: string
  gradeLevel: string
  subjectOrder: number
} {
  const { countryCode: countryCodeParam, grade, topic, subject } = router.query
  let countryCode = (countryCodeParam as string)?.split('-')[1] || ''
  let gradeLevel = grade as string
  const subjectOrder = Number(topic) || Number(subject) || 0

  if (!Object.values(CurriculumCountryCodes).includes(countryCode as CurriculumCountryCodes)) {
    countryCode = ''
  }

  if (!Number(gradeLevel)) {
    gradeLevel = ''
  }

  return { countryCode, gradeLevel, subjectOrder }
}
